import { render } from "./lista_SpareParts.vue?vue&type=template&id=3cee988a"
import script from "./lista_SpareParts.vue?vue&type=script&lang=js"
export * from "./lista_SpareParts.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__